(function (angular) {
    angular.module('bizPartEngage').provider('bizEffects', effectsProvider);

    effectsProvider.$inject = ['fireworksProvider'];

    function effectsProvider(fireworks) {

        function Show(effectSystemName) {
            if (effectSystemName === 'CONFETTI') {
                confetti();
            } else if (effectSystemName === 'FIREWORKS') {
                fireworks.showFireworks();
            }
        }        
        
        return {
            Show: Show,            
            $get: function () {
                return {
                    Show: Show
                };
            }
        }
    }
})(window.angular);